import { IDraftingMediaAssets } from "@shared/lib/types/drafting";
import { Loader2 } from "lucide-react";
import styles from "./reviewPanel.module.scss";

function formatStamp(seconds: number) {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}

export function DraftTranscript({
  lines,
  status,
  currentTime,
  onSeek,
}: {
  lines: NonNullable<IDraftingMediaAssets["transcription"]>;
  status?: IDraftingMediaAssets["transcriptionStatus"];
  currentTime: number;
  onSeek: (time: number) => void;
}) {
  if (status === "Pending") {
    return (
      <p className={styles.transcriptEmpty}>
        <Loader2 size={14} className="spin-animation" />
        Transcribing this draft…
      </p>
    );
  }
  if (!lines.length) {
    return <p className={styles.transcriptEmpty}>No transcript for this draft yet.</p>;
  }

  return (
    <div className={styles.transcript}>
      {lines.map((line) => {
        const active = currentTime >= line.start && currentTime < line.end;
        return (
          <button
            key={line._id || `${line.start}-${line.text}`}
            type="button"
            className={active ? styles.lineActive : styles.line}
            onClick={() => onSeek(line.start)}
          >
            <span className={styles.stamp}>
              {formatStamp(line.start)}–{formatStamp(line.end)}
            </span>
            <span className={styles.lineText}>{line.text}</span>
          </button>
        );
      })}
    </div>
  );
}
